<template>
  <v-col class="pb-7">
    <transition name="fade" mode="out-in">
      <v-row v-if="loading">
        <v-progress-circular
          color="blue darken-1"
          indeterminate
          class="mx-auto my-6"
        />
      </v-row>
      <div v-else>
        <v-row
          class="merchants-list"
          v-for="(regionObj, i) of regionsOrderedByDensity"
          :key="`region-${i}`"
        >
          <v-col cols="12" class="region-name"
            ><div class="display-1 mt-4 mb-0 font-weight-bold">{{
              regionObj.name
            }}</div></v-col
          >
          <v-col
            cols="12"
            class="merchant"
            v-for="(merchant, i) of regionObj.members"
            :key="`merchant-${i}`"
          >
            <div class="headline font-weight-bold">
              <template v-if="!!merchant['Shop Link']"
                ><a :href="merchant['Shop Link']" class="merchant-shop-link">{{
                  merchant['Shop Name']
                }}</a></template
              >
              <template v-else>{{ merchant['Shop Name'] }}</template>

              <v-btn
                :href="`https://instagram.com/${merchant['Instagram']}`"
                v-if="merchant['Instagram']"
                depressed
                tile
                small
                class="transparent pa-0 mt-n1 ml-2 ig-btn"
              >
                <v-icon small>mdi-instagram</v-icon></v-btn
              >
            </div>

            <div class="title font-italic merchant-description">{{
              merchant['Description']
            }}</div>
          </v-col>
        </v-row>
      </div>
    </transition>
  </v-col>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _groupBy from 'lodash/groupBy'
import _orderBy from 'lodash/orderBy'

export default {
  name: 'CommunityMembersList',
  components: {},
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    ...mapGetters('shop', ['getCommunityMembers']),
    regionsWithMembershipNumbers() {
      const merchantsByRegion = _groupBy(
        this.getCommunityMembers,
        'Region/City'
      )
      let regionsWithMembershipNumbers = {}
      Object.keys(merchantsByRegion).forEach((region) => {
        const members = _orderBy(merchantsByRegion[region], (m) =>
          m['Shop Name'].replace('The ', '')
        )
        regionsWithMembershipNumbers[region] = {
          name: region,
          numMembers: members.length,
          members,
        }
      })
      return regionsWithMembershipNumbers
    }, // regionsWithMembershipNumbers
    regionsOrderedByDensity() {
      return _orderBy(
        this.regionsWithMembershipNumbers,
        ['numMembers', 'name'],
        ['desc']
      )
    }, // regionsOrderedByDensity
  },
  async created() {
    this.loading = true
    await this.fetchCommunityMembers()
    this.loading = false
  },
  methods: {
    ...mapActions('shop', ['fetchCommunityMembers']),
  },
}
</script>

<style lang="scss">
.region-name {
  position: sticky;
  top: 48px;
  background: white;
  z-index: 3;
}
.merchant-shop-link {
  text-decoration: none;
}
.merchant-description {
  line-height: 1.7rem;
}
.v-btn.v-size--small.ig-btn {
  min-width: 30px;
}
</style>
